/**
 * File view.js.
 *
 * Handles frontend scripts
 */
(function ($) {
	'use strict';

	replaceHeroBannerImage();
	$( window ).on( 'resize', replaceHeroBannerImage );

	// Replace hero banner image.
	function replaceHeroBannerImage() {
		var windowWidth = $( window ).width();
		$( '.hero-banner' ).each( function() {
			var _this        = $( this );
			var mobileImage  = _this.data( 'mobile-image' );
			var desktopImage = _this.data( 'desktop-image' );
			if ( windowWidth < 768 && mobileImage ) {
				_this.css( 'background-image', 'inherit' ).addClass( 'hero-banner__mobile-image-wrap' );
				_this.find( '.hero-banner__mobile-image' ).remove();
				_this.find( '.hero-banner__body' ).prepend( '<div class="hero-banner__mobile-image"><img src="' + mobileImage + '"></div>' );
			} else if ( desktopImage ) {
				_this.css( 'background-image', 'url(' + desktopImage + ')' ).removeClass( 'hero-banner__mobile-image-wrap' );;
				_this.find( '.hero-banner__mobile-image' ).remove();
			}
		});
	}
})(jQuery);
